import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Αμερικάνικο ποδόσφαιρο",
    Baseball: "Μπέιζμπολ",
    Basketball: "Μπάσκετ",
    Boxing: "Μποξ",
    Chess: "Σκάκι",
    Cricket: "Κρίκετ",
    Darts: "Darts",
    Entertainment: "Entertainment",
    "E-Sports": "E-Sports",
    Football: "Ποδόσφαιρο",
    "Formula 1": "Φόρμουλα 1",
    "Gaelic Football": "Γαελικό ποδόσφαιρο",
    "Generic Sport": "Generic Sport",
    Golf: "Γκόλφ",
    "Greyhound Racing": "Greyhound Racing",
    Handball: "Χάντμπολ",
    "Ice Hockey": "Χόκεϊ επί πάγου",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politics",
    "Rugby League": "Rugby League",
    "Rugby Union": "Rugby Union",
    Snooker: "Μπιλιάρδο",
    "Table Tennis": "Πινγκ Πoνγκ",
    Tennis: "Τένις",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} να κερδίσει",
    WinFirstRound: "{name} για να κερδίσετε τον πρώτο γύρο",
    FirstTouchdown: "{name} για να σκοράρει πρώτα ένα touchdown",
    FirstTry: "{name} θα σκοράρει μία προσπάθεια πρώτη",
    TotalGoals: "{name} Σύνολο γκολ",
    TotalRuns: "{name} Σύνολο runs",
    TotalPoints: "{name} σύνολο πόντοι",
    TopBatsman: "{name} για να γίνετε Κορυφαίος Μπάτσμαν",
    TopBowler: "{name} για να γίνετε Κορυφαίο σφαιριστής",
    FirstScore: "{name} θα σκοράρει πρώτη"
  },
  PromoTexts: {
    Pick: "Κάντε τις επιλογές σας",
    Bet: "Στοιχηματίστε",
    Pays: "Κέρδος"
  },
  DateTimeTexts: {
    Today: "Σήμερα",
    Tomorrow: "Αύριο",
    Live: "ζων"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Κάντε τις επιλογές σας",
    Return: "Κέρδος",
    Stake: "Στοιχηματίστε",
    Draw: "X"
  },
  H2HTexts: {
    "Goals scored": "Γκολ που επιτεύχθησαν",
    Shots: "Σουτ",
    "Shots on target": "Σουτ εντός στόχου",
    "Ball possession": "Κατοχή",
    "Goals conceded": "Γκολ που δέχτηκε",
    "Per match": "ανά αγώνα",
    H2H: "Σύγκριση",
    W: "N",
    D: "I",
    L: "H"
  }
};
